<template>
  <VerificationCodeForm />
</template>

<script setup>
import { onMounted } from "vue";
import { useRouter, onBeforeRouteLeave, useRoute } from "vue-router";
import { useTitle } from "@vueuse/core";
import VerificationCodeForm from "@/components/forms/VerificationCodeForm.vue";
import useThirdPartyScripts from "@/composables/api/useThirdPartyScripts";
import { useGlobalStore } from "@/stores/globalStore";
import { useIdentityQueueStore } from "@/stores/identityQueueStore";

const route = useRoute();
const router = useRouter();
const { useSiftScript } = useThirdPartyScripts();
const globalStore = useGlobalStore();
const identityQueueStore = useIdentityQueueStore();

const handleRedirect = () => {
  identityQueueStore.fetchNextIdentityRoute(route).then((nextRoute) => {
    router.push(nextRoute);
  });
};

onMounted(() => {
  const skipVerificationCode =
    globalStore.getMerchantSettings?.VALIDATE_MSISDN === false &&
    globalStore.getMerchantSettings?.VALIDATE_EMAIL === false;

  if (skipVerificationCode) {
    handleRedirect();
  }
});

useTitle("Banxa - Enter your code");
onBeforeRouteLeave(() => useSiftScript()); // grabs the userID for Sift
</script>
